import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'system-connection-details-dialog',
  templateUrl: './system-connection-details.dialog.html',
  styleUrls: ['./system-connection-details.dialog.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    FlexLayoutModule,
    MatIconModule
  ]
})
export class SystemConnectionDetailsDialog {
  details: { key: string; value: string }[] = [];

  constructor(
    public dialogRef: MatDialogRef<SystemConnectionDetailsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { name: string; details: { [key: string]: string } }
  ) {
    this.details = Object.entries(data.details).map(([key, value]) => ({ key, value }));
  }

  onClose(): void {
    this.dialogRef.close();
  }
} 